import { render, staticRenderFns } from "./tow.vue?vue&type=template&id=45a799fc&scoped=true"
import script from "./tow.vue?vue&type=script&lang=js"
export * from "./tow.vue?vue&type=script&lang=js"
import style0 from "./tow.vue?vue&type=style&index=0&id=45a799fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a799fc",
  null
  
)

export default component.exports